import styled from 'styled-components';
import { colorLuminance } from 'utils/colors';

export const StyledStatusSelector = styled.div`
&.s-user{
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 0;
    min-height: 0;
    padding: 10px 15px 10px 10px;
    position: relative;
    .ant-dropdown-trigger{
        display: flex;
        flex: 1;
        min-width: 0;
    }
    .avatar{
        margin-right: 10px;
        .s-status{
            border-color: ${props => colorLuminance(props.theme.mainColor1, 0.15)};
        }
    }
    .icon-container{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: -5px;
    }
}
`;
